import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface SectionRevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function SectionReveal({
  children,
  className = '',
  delay = 0
}: SectionRevealProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 40
  }} transition={{
    duration: 0.7,
    delay,
    ease: 'easeOut'
  }} className={className} data-id="element-14">
      {children}
    </motion.div>;
}